<style>
p {
  @apply leading-normal tracking-normal text-center whitespace-pre-wrap text-2xl;
}
.font-size-sm {
  @apply text-sm;
}
.font-size-normal {
  @apply text-base;
}
.font-size-lg {
  @apply text-lg;
}
.font-size-xl {
  @apply text-xl;
}
.font-size-2xl {
  @apply text-2xl;
}
.font-size-3xl {
  @apply text-3xl;
}
.font-weight-normal {
  @apply font-normal;
}
.font-weight-semibold {
  @apply font-semibold;
}
.font-weight-bold {
  @apply font-bold;
}
.text-align-center {
  @apply text-center;
}
.text-align-left {
  @apply text-left;
}
.text-align-right {
  @apply text-right;
}
p > :global(a) {
  color: var(--primary);
}
p > :global(a:hover) {
  @apply underline;
}
@screen md {
  p {
    @apply -mx-12;
  }
}
@screen lg {
  p {
    @apply -mx-24;
  }
}
</style>

<script>
import { sanitize } from "@shared/utils/sanitize"
export let content = ""
export let className = ""
$: safeContent = sanitize(content)
</script>

<p class="{className}">
  {@html safeContent}
</p>
